Application.SvgIcons = {
    ui: {
        container: '.svg-icon'
    },
    ready: function(){

        $(this.ui.container).each(function(){
            if ($(this).data('svg-icon-initialized')){
                return;
            }
            var icon = new Application.SvgIcon(this);
            icon.setIcon($(this).data('icon'), $(this).data('color'));
        });

    }
}

Application.SvgIcon = function(el){

    window.i = this;

    // create element and SVG object
    this.element = el ? el : this._createElement();
    this.svg = new SVG(this.element).size($(this.element).width(), 1);

    // init
    this.bgBox = {
        x: 0,
        y: 0,
        w: 0,
        h: 0,
        a: 0
    };
    this.bg = null;
    this.bgImage = null;
    this.mask = null;
    this.png = null;
    this.settings = {x:null,y:null,w:null,h:null,a:null};

    // set default background
    this.setBackground('#fff');

}

Application.SvgIcon.FIT_WIDTH = 'width';
Application.SvgIcon.FIT_WIDTH_RATIO = 'widthRatio';
Application.SvgIcon.FIT_CONTAIN = 'contain';
Application.SvgIcon.FIT_COVER = 'cover';
Application.SvgIcon.prototype = $.extend({
    _createElement: function(){

        return $('<div class="svg-icon" />').data('svg-icon-initialized', true).get(0);

    },
    _loadSvg: function(url, callback){

        $.ajax(url, {
            dataType: 'text',
            success: function(data){
                callback(data);
            }
        });

    },
    _createIconSvg: function(data){

        // create element
        var el = this._createElement();

        // create svg
        var svg = new SVG(el).size(1000, 1000);
        return svg.svg(data);

    },
    _getIconPath: function(svg){

        // find path
        return svg.select('path').first();

    },
    _fit: function(el, type, ratio){

        // get dimensions
        var width = $(this.element).width();
        var height = $(this.element).height();
        var bbox = el.bbox();

        if (!bbox.w && !bbox.h) {

            // no size element
            el.size(width, height);

        } else if (type === Application.SvgIcon.FIT_WIDTH_RATIO){

            // move path
            el.move(0,0);

            // get bbox and resize proportionally
            el.size(width * ratio, bbox.h / bbox.w * width * ratio);

        } else if (type === Application.SvgIcon.FIT_WIDTH){

            // move path
            el.move(0,0);

            // get bbox and resize proportionally
            el.size(width, bbox.h / bbox.w * width);

        } else if (type === Application.SvgIcon.FIT_COVER){

            if (width / height > bbox.w / bbox.h){
                var h = (bbox.h / bbox.w) * width;
                el.size(width, h);
                // move path
                el.move(0, (height - h) / 2);
            } else {
                var w = bbox.w / bbox.h * height;
                el.size(w, height);
                // move path
                el.move((width - w) / 2,0);
            }

        } else { // FIT_CONTAIN

            // move path
            el.move(0,0);

            if (width / height > bbox.w / bbox.h){
                var w = (bbox.w / bbox.h) * height;
                el.size(w, height);
            } else {
                var h = bbox.h / bbox.w * width;
                el.size(width, h);
            }

        }

    },
    _resizeTo: function(path){

        // get bbox and resize proportionally
        var bbox = path.bbox();
        this.svg.size(bbox.w, bbox.h);

    },
    getSvg: function(){

        return this.svg.svg();

    },
    getSettings: function(){

        return this.settings;

    },
    loadSettings: function(settings){

        this.moveBackground(settings.x, settings.y);
        this.resizeBackground(settings.w, settings.h);
        this.rotateBackground(settings.a);

    },
    setPng: function(url, fit, callback){

        var self = this;

        // file
        var png = this.svg.image(url).loaded(function (data) {

            // remove existing icon or png
            if (self.mask){
                self.mask.remove();
            }
            if (self.png){
                self.png.remove();
            }

            // resize and replace
            self.png = png;
            self._fit(self.png, fit ? fit : Application.SvgIcon.FIT_WIDTH);
            self._resizeTo(self.png);

            // callback
            if (typeof callback === 'function') {
                callback();
            }

        });

    },
    setIcon: function(url, color, fit, callback){

        var self = this;

        this._loadSvg(url, function(data){

            // remove existing icon or png
            if (self.mask){
                self.mask.remove();
            }
            if (self.png){
                self.png.remove();
            }

            // get path
            var iconSvg = self._createIconSvg(data);
            var path = self._getIconPath(iconSvg);

            // clone path and resize
            self.mask = self.svg.path(path.attr('d'));
            self._fit(self.mask, fit ? fit : Application.SvgIcon.FIT_WIDTH);
            self._resizeTo(self.mask);

            // change background or reclip only
            if (color){
                self.setBackground(color);
            }else{
                self._reclip();
            }

            // callback
            if (typeof callback === 'function'){
                callback();
            }

        });

    },
    moveBackground: function(x, y){

        this.bgBox.x = x;
        this.bgBox.y = y;
        this.bg.move(x, y);
        this.mask.move(-x, -y);

        this.settings.x = x;
        this.settings.y = y;

    },
    resizeBackground: function(w, h){

        // save
        this.bgBox.w = w;
        this.bgBox.h = h;

        // resize when not rotated
        this._rotate(this.bgImage, 0);
        // resize
        this.bgImage.size(w, h);
        // restore rotation
        this._rotate(this.bgImage, this.bgBox.a);

        // update
        this.settings.w = w;
        this.settings.h = h;

    },
    rotateBackground: function(a){

        // save
        this.bgBox.a = a;
        // rotate
        this._rotate(this.bgImage, a);

        // update
        this.settings.a = a;

    },
    _rotate: function(el, a){

        // convert from rad to deg
        var deg = a * 180 / Math.PI;
        // rotate with the elements center as the transform origin
        el.transform({rotation: deg, cx: el.x() + el.bbox().w / 2, cy: el.y() + el.bbox().h / 2})

    },
    setBackground: function(color, callback){

        var self = this;

        var isFile = /^https?:\/\//.test(color);
        var isBase64 = /^data:image/.test(color);

        if (isFile) {

            // file
            var img = this.svg.image(color).loaded(function (data) {

                // resize and replace
                this.size(data.width, data.height);
                self._replaceBg(img);

                // callback
                if (typeof callback === 'function') {
                    callback();
                }

            });

        } else if (isBase64){

            // base 64 string
            var img = this.svg.image(color).loaded(function(data) {

                // resize and replace
                this.size(data.width, data.height)
                self._replaceBg(img);

                // callback
                if (typeof callback === 'function'){
                    callback();
                }

            });

        }else{

            // solid color rect
            var rect = this.svg.rect().fill(color);

            // replace
            this._replaceBg(rect);

            // callback
            if (typeof callback === 'function'){
                callback();
            }

        }

    },
    getBackgroundBbox: function(){

        return this.bgBox;

    },
    _replaceBg: function(i){

        // remove existing bg
        if (this.bg){
            this.bg.remove();
        }

        // assign new bg
        this.bg = this.svg.group();
        this.bgImage = i;
        this.bg.add(this.bgImage);

        // reapply clipping mask
        this._reclip();

    },
    _resizeBg: function(){

        // resize bg to fit first
        this._fit(this.bgImage, Application.SvgIcon.FIT_COVER);
        // reset cover position
        this.bgImage.move(0,0);

        // than make it slighty bigger, to make sure it covers the whole mask
        var paddingX = 85;
        var bbox = this.bgImage.bbox();
        var paddingY = paddingX * bbox.h / bbox.w;

        // dimensions
        var w = bbox.w + paddingX * 2
        var h = bbox.h + paddingY * 2;
        // size
        this.resizeBackground(w, h);

        // position
        var x = (this.mask.bbox().w - this.bgImage.bbox().w) / 2;
        var y = bbox.y - paddingY;
        // center the blob around the icon
        this.moveBackground(x, y);

        this.settings = {x:x, y:y, w:w, h:h, a:0};

    },
    _unclip: function(){

        // use as clipping mask
        this.bg.unclip();

    },
    _reclip: function(){

        if (!this.mask){
            return;
        }

        // resize
        this._resizeBg();

        // use as clipping mask
        var clip = this.svg.clip().add(this.mask);
        this.bg.clipWith(clip);

    }
}, Application.SvgIcon.prototype);